import { render, staticRenderFns } from "./gptTechnology.vue?vue&type=template&id=b7e7a738&scoped=true"
import script from "./gptTechnology.vue?vue&type=script&lang=js"
export * from "./gptTechnology.vue?vue&type=script&lang=js"
import style0 from "./gptTechnology.vue?vue&type=style&index=0&id=b7e7a738&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7e7a738",
  null
  
)

export default component.exports